import * as React from "react";

import { DashboardBadgeModel } from "models/ApiModels";

import { TableRow, TableCell } from "@mui/material";

import MuiLink from "components/MuiExtras/MuiLink";
import MuiAvatar from "components/MuiExtras/MuiAvatar";
import { AppImages } from "assets/appResources";


interface IRenderBadgeModelListProps {
    indexOffset: number;
    items: DashboardBadgeModel[];
    onSelect?: (item: DashboardBadgeModel) => void;
    onDrillDown: (item: DashboardBadgeModel) => void;
}

export const RenderBadgeModelList: React.FC<IRenderBadgeModelListProps> = (props) => {

    const { indexOffset, items, onDrillDown, onSelect } = props;

    return (
        <>
            {
                items.map((v, index) => {

                    return (
                        <TableRow key={index}>
                            <TableCell style={{ width: 1 }}>{indexOffset + index + 1}</TableCell>

                            <TableCell style={{ width: 1 }}>
                                <MuiAvatar borderColor="warning" backgroundColor="transparent" src={v.thumbnailUrl || AppImages.DefaultBadgeThumbnail} />
                            </TableCell>

                            <TableCell>
                                {
                                    onSelect
                                        ? (
                                            <MuiLink
                                                color="secondary"
                                                onClick={() => onSelect(v)}
                                            >
                                                {v.name}
                                            </MuiLink>
                                        )
                                        : <>{v.name}</>
                                }
                            </TableCell>

                            {
                                v.total &&
                                <TableCell align="right">
                                    <MuiLink
                                        color="secondary"
                                        onClick={() => onDrillDown(v)}
                                    >
                                        {v.total.toLocaleString()}
                                    </MuiLink>
                                </TableCell>
                            }
                        </TableRow>
                    );
                })
            }
        </>
    );
};
